import { useState } from "react";
import { toast } from "react-toastify";
import { useExportLocations } from "./useExportLocations";
import { useExportVisits } from "./useExportVisits";

export function useExportLocationsWithVisits() {
  const [isLoading, setIsLoading] = useState(false);
  const locations = useExportLocations();
  const visits = useExportVisits();

  const handleExport = async () => {
    setIsLoading(true);

    try {
      const results = await Promise.allSettled([
        locations.handleExport(),
        visits.handleExport(),
      ]);

      const locationsSuccess = results[0].status === "fulfilled";
      const visitsSuccess = results[1].status === "fulfilled";

      if (!locationsSuccess && !visitsSuccess) {
        toast.error("Erro ao exportar relatórios de locais e visitas");
        return;
      }
    } catch {
      toast.error("Erro ao exportar relatórios de locais e visitas");
    } finally {
      setIsLoading(false);
    }
  };

  return { handleExport, isLoading };
}
